import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import ReportView from '@pages/ReportView'
import { postToParent } from './embedAuth'

// Chromeless wrapper around the existing ReportView.
// We rely on the route alias `/embed/reports/:reportId` so useParams() inside
// ReportView resolves the same way as `/reports/:reportId` does in the
// regular shell. Layout (sidebar, header, breadcrumbs) is omitted.

const EmbedReportView = () => {
  const { reportId } = useParams()

  useEffect(() => {
    postToParent({ type: 'cb2-report-loaded', reportId })
    const onResize = () => {
      postToParent({
        type: 'cb2-resize',
        height: document.documentElement.scrollHeight,
      })
    }
    onResize()
    const ro = new ResizeObserver(onResize)
    ro.observe(document.documentElement)
    return () => ro.disconnect()
  }, [reportId])

  /*
   * The `p-6` is load-bearing and stays — checked against A1 (2026-08-26).
   *
   * `.report-shell`, which ReportView renders inside, is written to sit in a
   * 24px-padded parent (`<main>`'s p-6 in the app shell). The embed has no
   * Layout and therefore no <main> at all (main.jsx mounts EmbedApp; EmbedApp
   * has no Layout), so this div is the ONLY thing that can play that part. Keep
   * them in step: one 24px here, the shell's own padding on top, and the embed's
   * gutter is arithmetically identical to the app's — 32px on a phone-width
   * frame, 82px from 640px, 90px from 1280px. Adding padding here would
   * double-gutter the iframe; removing it would under-gutter it by 24px.
   *
   * Known and deliberate: an IQ panel is usually narrower than a browser window,
   * and the shell's media queries measure the IFRAME, so an 800px frame spends
   * 164px of its width on gutter. That is what "+50px on every viewport" means
   * for a small viewport; if it reads as too much in IQ, the fix is a shell
   * variant in index.css, not a second padding rule here.
   */
  return (
    <div className="bg-gray-50 p-6 min-h-screen embed-mode">
      <ReportView backTo="/embed/reports" />
    </div>
  )
}

export default EmbedReportView
